module.exports = __webpack_public_path__ + "media/BK-club.3b686391.mp4";